import { gql } from "@apollo/client";

export const FETCH_ALL_PROJECT_TASKS = gql`
  query FETCH_ALL_PROJECT_TASKS {
    projects {
      total
      results {
        id
        name
      }
    }
  }
`;

export const SAVE_PROJECT_TASKS_ORDERING = gql`
  mutation SAVE_PROJECT_TASKS_ORDERING($ids: [ID!]!) {
    saveProjectTasksOrdering(ids: $ids) {
      tasks {
        id
        ordering
      }
    }
  }
`;
